import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { useRecoilState } from 'recoil'
import { getImage } from 'gatsby-plugin-image'
import { Parallax } from 'react-scroll-parallax'
import PressBanner from 'src/components/shared/PressBanner'
import useReviews from 'src/hooks/useReviews'

import FeaturedBundle from './FeaturedBundle'
import BuyABundle from './BuyABundle'
import Powders from '../OurProducts/Powders'
import Grooming from '../OurProducts/Grooming'
import Accessories from '../OurProducts/Accessories'
import Dental from '../OurProducts/Dental'
import { Singles } from '../OurProducts'
import Reviews from '../PDP/Reviews'

import { H1 } from '../shared/text'
import { media } from '../../styles/util'
import { colors } from '../../styles/variables'

import { productDetailState } from '../../actions/products'

import { trackCollectionViewEvent } from '../../utils/event-tracking'
import Billboard from './Billboard'
import AllImg from '../../assets/img/categories/all.png'
import KonaImg from '../../assets/img/categories/kona.png'

const Section = styled.div`
  background-color: #fff;
  width: 100%;
  color: ${colors.navy};

  ${media.mobile`
    padding: 43px 0 0 0;
  `}
  ${media.tablet`
    padding: 75px 0 0 0;
  `}
  ${media.desktop`
    padding: 70px 0 0 0;
  `}
`

const Container = styled.div`
  width: 100%;
  justify-content: space-around;

  ${media.mobile`
    margin-top: 30px;
  `}
  ${media.tablet`
    margin-top: 80px;
  `}
  ${media.desktop`
    margin-top: 14px;
  `}

  & h2 {
    color: ${colors.navy};
    ${media.mobile`
      font-size: 42px;
      line-height: 1.35 !important;
      padding: 0 20px;
    `}
    ${media.desktop`
      font-size: 86px;
      margin-top: -30px;
    `}
  }
`

const Header = styled.div`
  width: 100%;
  text-align: center;
  position: relative;

  ${media.mobile`
    min-height: 350px;
  `}
  ${media.tablet`
    min-height: 250px;
  `}
  ${media.desktop`
    min-height: 400px;
  `}
`

const query = graphql`
  query {
    featuredProductImg: file(relativePath: { regex: "/tins/comfy-pup-bundle.png/" }) {
      childImageSharp {
        gatsbyImageData(width: 800)
      }
    }
  }
`

const Products = ({ isAlternate }: { isAlternate?: boolean }) => {
  const { featuredProductImg } = useStaticQuery(query)
  const [productMap] = useRecoilState(productDetailState)
  const reviewsHook = useReviews()

  const { fetching } = productMap

  useEffect(() => {
    if (!fetching && productMap?.bySlug) {
      const productSlugs = Object.keys(productMap.bySlug)
      trackCollectionViewEvent(productMap, productSlugs)
    }
  }, [fetching])

  return (
    <Section>
      <Container>
        <Billboard height={580} image={AllImg} />
        <PressBanner bg={'lightBlue'} color="navy" ticking homepage hideMobile />
        <Singles title="Supplements" isProductLibrary isAlternate={isAlternate} />
        <Powders title="Toppers" />
        <Dental title="Dental" />
        <Grooming title="Grooming" />
        <Accessories title="Accessories" />
        {/* <Candles title="Candles" /> */}
        <BuyABundle title="Bundles" isProductLibrary />
        <Billboard
          title={'made for\nkona'}
          image={KonaImg}
          ctaText="Take The Quiz"
          ctaLink="/consultation"
          text={
            'Tell us a bit about your dog and get tailor-made supplement recommendations based on factors like age, breed, diet, and history.'
          }
        />
      </Container>
    </Section>
  )
}

export default Products
